import { Box, Fade, Stack } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import {
  IAuthState,
  tryConfirmLogin,
} from "../../stateManagement/reducers/authReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import Header from "../generalLayout/components/Header";
import Background from "./Background";

const GeneralLayoutAlt = () => {
  const dispatch = useDispatch<any>();
  const { user, authToken, confirmingLogin } = useSelector<
    IRootReducerT,
    IAuthState
  >((state) => state.auth);
  const location = useLocation();

  const [showCartModal, setShowCartModal] = useState(false);

  let layout: ReactNode | null = null;

  const [show, setShow] = useState(false);

  const [isInitRender, setIsInitRender] = useState(true);
  useEffect(() => {
    if (isInitRender) {
      setIsInitRender(false);
      return;
    }

    setShow(false);
  }, [isInitRender, location.pathname]);

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setShow(true);
      }, 100);
    }
  }, [show]);

  useEffect(() => {
    if (!user) {
      dispatch(tryConfirmLogin({ authToken: authToken ?? "" }));
    }
  }, []);

  return (
    <>
      <Stack
        alignItems="center"
        width={"100%"}
        spacing={4}
        sx={{
          display: "flex",
          backgroundColor: "rgba(12, 87, 39, 1)",
          position: "relative",
          overflow: "hidden",
          minHeight: "100vh",
          p: 0,
          pt: 0,
          pb: 0,
        }}
      >
        <Header setShowCartModal={setShowCartModal} />
        <Fade
          in={show}
          style={{
            transitionDelay: show ? "250ms" : "0ms",
            transitionDuration: "500ms",
          }}
        >
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: {
                xs: 0,
                sm: 0,
              },
              position: "relative",
              pb: "0 !important",
              display: "flex",
              width: "100%",
              minHeight: {
                xs: "80vh",
                md: "100vh",
              },
              marginTop: "0 !important",
              overflow: "hidden",
            }}
          >
            <Background />
            {show && <Outlet />}
          </Box>
        </Fade>
        <Footer />
      </Stack>
    </>
  );
};

export default GeneralLayoutAlt;
